if (!customElements.get('cart-item-services-and-delivery')) {
    customElements.define(
        'cart-item-services-and-delivery',
        class CartItemServicesAndDelivery extends HTMLElement {

            static LIFTING_INPUT_NAME = 'lifting_service';
            static LIFTING_INSTALLATION_INPUT_NAME = 'lifting_installation_service';

            static ATTR_LIFTING = '_is_lifting_service';
            static ATTR_LIFTING_INSTALLATION = '_is_lifting_and_installation_service';

            //used for identifying cart line
            static ATTR_SERVICE_RELATION_ID = '_service_relation_id';

            static CHECKOUT_BUTTON_SELECTOR = 'button[name="checkout"]';

            options = {
                properties: {},
                shippingRates: {},
                packagesInfo: {},

                presaleDate: null,
                estimatedDeliveryDays: null,

                line: null,
                linekey: null,
                currentCountryIsoCode: '',
                currencySymbol: '',

                itemId: '',
                itemQty: 1,
                quantityVariantId: '',

                defaultServiceTitle: '',
                defaultServiceDescription: '',
                defaultServiceShowTooltip: true,
                liftingServiceTitle: '',
                liftingServiceDescription: '',
                liftingServiceShowTooltip: true,
                liftingInstallationServiceTitle: '',
                liftingInstallationServiceDescription: '',
                liftingInstallationServiceShowTooltip: true,
                deliveryAndServicesTitle: '',
                deliveryAndServicesDescription: '',
                shippingPriceTitle: '',
                shippingPriceDescription: '',
                shippingDiscountDescription: '',
                shippingDiscountDescriptionColor: '',
                shippingDiscountDescriptionTextColor: '',
                estimatedDeliveryTitle: '',
                numberOfPackagesTitle: '',
                additionalServicesTitle: '',

                businessDayTitle: '',
                businessDaysTitle: '',
                businessDaysGenitiveTitle: '',

                badgePositionDesktop: 'under_title',
                badgePositionMobile: 'under_title',

                serviceDefaultBadgeText: '',
                serviceDefaultBadgeTextColor: '',
                serviceDefaultBadgeBgColor: '',
                serviceDefaultBorderColor: '',
                serviceDefaultItemBgColor: '',

                serviceLiftingBadgeText: '',
                serviceLiftingBadgeTextColor: '',
                serviceLiftingBadgeBgColor: '',
                serviceLiftingBorderColor: '',
                serviceLiftingItemBgColor: '',

                serviceLiftingInstallationBadgeText: '',
                serviceLiftingInstallationBadgeTextColor: '',
                serviceLiftingInstallationBadgeBgColor: '',
                serviceLiftingInstallationBorderColor: '',
                serviceLiftingInstallationItemBgColor: '',
            };

            shippingPrice = null;
            shippingOldPrice = null;

            async connectedCallback() {
                this.extractOptionsFromDataset();
                this.render();
                this.attachEvents();
                this._autoCleanupIfPriceIsZero();

                this.requestShippingPrices()
                    .then(([shippingPrice, shippingOldPrice]) => {
                        this.shippingPrice = shippingPrice;
                        this.shippingOldPrice = shippingOldPrice;

                        const shippingPriceContainer = this.querySelector('.shipping-price-container');
                        if (shippingPriceContainer) {
                            setTimeout(() => {
                                shippingPriceContainer.innerHTML = this.renderShippingPrice();
                            }, 700);
                        }
                    });
            }

            async requestShippingPrices() {
                const servicesAndDeliveryUtilsService = window.serviceAndDeliveryUtils.ServicesAndDeliveryUtilsService;

                const [shippingPrice, cart] = await Promise.all([
                    servicesAndDeliveryUtilsService.getShippingPrice(),
                    servicesAndDeliveryUtilsService.requestCart()
                ]);

                const shippingPriceItems = shippingPrice?.rates?.items || [];
                const filteredItems = cart?.items?.filter(item => !item.properties || item.properties['_is_service_product'] !== true) || [];
                const itemIndex = filteredItems.findIndex(item => item.key === this.options.linekey);
                const shippingPriceItem = (itemIndex !== -1) ? shippingPriceItems[itemIndex] : null;

                return shippingPriceItem
                    ? [shippingPriceItem?.price, shippingPriceItem?.old_price]
                    : [null, null];
            }

            renderTooltip(text) {
                return `
                    <div class="cart-item-service-tooltip">
                        <i class="cart-item-service-tooltip-icon">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.99992 13.6666C3.31802 13.6666 0.333252 10.6818 0.333252 6.99992C0.333252 3.31802 3.31802 0.333252 6.99992 0.333252C10.6818 0.333252 13.6666 3.31802 13.6666 6.99992C13.6666 10.6818 10.6818 13.6666 6.99992 13.6666ZM6.99992 12.3333C9.94545 12.3333 12.3333 9.94545 12.3333 6.99992C12.3333 4.0544 9.94545 1.66659 6.99992 1.66659C4.0544 1.66659 1.66659 4.0544 1.66659 6.99992C1.66659 9.94545 4.0544 12.3333 6.99992 12.3333ZM6.33325 3.66659H7.66659V4.99992H6.33325V3.66659ZM6.33325 6.33325H7.66659V10.3333H6.33325V6.33325Z" fill="black"/> </svg>
                        </i>
                        <div class="cart-item-service-tooltip-text">
                            ${text}
                        </div>
                    </div>
                `;
            }

            renderShippingPrice() {
                const shippingPrice = this.shippingPrice
                    ? this.formatMinorToMajorUnits(this.shippingPrice) + ' ' + this.options.currencySymbol
                    : '-';

                const shippingOldPrice = this.shippingOldPrice
                    ? this.formatMinorToMajorUnits(this.shippingOldPrice) + ' ' + this.options.currencySymbol
                    : null;

                return `
                    <div class="shipping-price">
                        <span class="shipping-price-image-title">
                            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M19.86 6.77L17.29 2.49001C17.11 2.19001 16.78 2 16.43 2H13V1C13 0.45 12.55 0 12 0H1C0.45 0 0 0.45 0 1V13C0 13.55 0.45 14 1 14H2.18C2.59 15.16 3.69 16 5 16C6.31 16 7.4 15.16 7.82 14H12.19C12.6 15.16 13.7 16 15.01 16C16.32 16 17.41 15.16 17.83 14H19.01C19.56 14 20.01 13.55 20.01 13V7.28C20.01 7.1 19.96 6.92 19.87 6.77H19.86ZM15.87 4.01L17.67 7.01H13V4.01H15.87ZM5 14.01C4.45 14.01 4 13.56 4 13.01C4 12.46 4.45 12.01 5 12.01C5.55 12.01 6 12.46 6 13.01C6 13.56 5.55 14.01 5 14.01ZM11 12.01H7.82C7.41 10.85 6.31 10.01 5 10.01C3.69 10.01 2.6 10.85 2.18 12.01H2V2.01H11V12.01ZM15 14.01C14.45 14.01 14 13.56 14 13.01C14 12.46 14.45 12.01 15 12.01C15.55 12.01 16 12.46 16 13.01C16 13.56 15.55 14.01 15 14.01ZM17.82 12.01C17.41 10.85 16.31 10.01 15 10.01C14.23 10.01 13.53 10.31 13 10.79V9.01H18V12.01H17.82Z" fill="black"/> </svg>    
                            <span class="shipping-price-title">${this.options.shippingPriceTitle}</span>
                            ${this.renderTooltip(this.options.shippingPriceDescription)}
                        </span>
                        <span class="shipping-price-content">
                            ${shippingPrice}
                            ${shippingOldPrice !== null ? `
                            <span class="item-old-shipping-price">
                                ${shippingOldPrice}
                            </span>
                            <div class="shipping-discount-label" style="background-color:${this.options.shippingDiscountDescriptionColor}; color:${this.options.shippingDiscountDescriptionTextColor}">${this.options.shippingDiscountDescription}</div>
                            ` : ''}
                        </span>
                    </div>
                `;
            }

            renderDeliveryDate() {
                let timeToDeliver = '';
                try {
                    timeToDeliver = this.getTimeToDeliver();
                } catch (error) {
                    console.error(`renderDeliveryDate error: ${error.message}`);
                }

                return `
                    <div class="delivery-time">
                        <span class="delivery-time-image-title">
                            <span class="delivery-time-title">${this.options.estimatedDeliveryTitle}&nbsp;</span>
                        </span>
                        <span class="delivery-time-content">
                            ${timeToDeliver || ''}
                        </span>
                    </div>
                `;
            }

            renderPackagesQty() {
                const packagesQty = Array.isArray(this.options.packagesInfo) ? this.options.packagesInfo.length * this.options.itemQty : '-';

                return `
                    <div class="packages-qty">
                        <span class="packages-qty-image-title">
                            <span>${this.options.numberOfPackagesTitle}&nbsp;</span>
                        </span>
                        <span class="packages-qty-content">
                            ${packagesQty}
                         </span> 
                    </div>
                `;;
            }

            getInputNames() {
                const suffix = this.options.linekey || this.options.itemId || '';
                return {
                    lifting: `${CartItemServicesAndDelivery.LIFTING_INPUT_NAME}_${suffix}`,
                    liftingInstallation: `${CartItemServicesAndDelivery.LIFTING_INSTALLATION_INPUT_NAME}_${suffix}`,
                    noService: `no_additional_service_${suffix}`,
                };
            }

            renderBadge(text, textColor, bgColor) {
                if (!text) return '';
                const style = [
                    bgColor ? `background-color:${bgColor}` : '',
                    textColor ? `color:${textColor}` : '',
                ].filter(Boolean).join(';');
                return `<span class="cart-item-service-badge"${style ? ` style="${style}"` : ''}>${text}</span>`;
            }

            renderServiceItemAttrs(borderColor, bgColor) {
                const vars = [
                    borderColor ? `--svc-border-color:${borderColor}` : '',
                    bgColor ? `--svc-bg-color:${bgColor}` : '',
                ].filter(Boolean);
                const cls = (borderColor || bgColor) ? ' cart-item-service--styled' : '';
                const styleAttr = vars.length ? ` style="${vars.join(';')}"` : '';
                return { cls, styleAttr };
            }

            renderDefaultOption() {
                const isLiftingChecked = this.normalizeBoolean(this.options.properties[CartItemServicesAndDelivery.ATTR_LIFTING]);
                const isLiftingAndInstallationChecked = this.normalizeBoolean(this.options.properties[CartItemServicesAndDelivery.ATTR_LIFTING_INSTALLATION]);
                const isDefaultChecked = !isLiftingChecked && !isLiftingAndInstallationChecked;
                const { noService } = this.getInputNames();
                const badge = this.renderBadge(
                    this.options.serviceDefaultBadgeText,
                    this.options.serviceDefaultBadgeTextColor,
                    this.options.serviceDefaultBadgeBgColor
                );
                const { cls, styleAttr } = this.renderServiceItemAttrs(
                    this.options.serviceDefaultBorderColor,
                    this.options.serviceDefaultItemBgColor
                );
                const tooltip = this.renderServiceTooltip(
                    this.options.defaultServiceShowTooltip,
                    this.options.defaultServiceDescription
                );

                return `
                    <div class="cart-item-service${cls}"${styleAttr}>
                        <label class="service-selector">
                            <input
                                type="radio"
                                name="${noService}"
                                value="none"
                                ${isDefaultChecked ? 'checked' : ''}
                            >
                            <span class="cart-item-service-name">
                                <span class="cart-item-service-name-row">
                                    <span class="cart-item-service-name-text">${this.options.defaultServiceTitle}</span>
                                    ${badge}
                                </span>
                                ${tooltip}
                            </span>
                        </label>
                    </div>
                `;
            }

            renderServiceTooltip(showTooltip, description) {
                if (!this.normalizeBoolean(showTooltip) || !description) {
                    return '';
                }
                return `<span class="cart-item-service-name-tooltip">${description}</span>`;
            }

            renderLiftingService() {
                const liftingServicePrice = this.getLiftingServicePrice();
                const isLiftingChecked = this.normalizeBoolean(this.options.properties[CartItemServicesAndDelivery.ATTR_LIFTING]);
                const { lifting } = this.getInputNames();

                let liftingServiceHtml = '';
                if (liftingServicePrice > 0) {
                    const priceFormatted = this.formatMinorToMajorUnits(liftingServicePrice * this.options.itemQty);
                    const badge = this.renderBadge(
                        this.options.serviceLiftingBadgeText,
                        this.options.serviceLiftingBadgeTextColor,
                        this.options.serviceLiftingBadgeBgColor
                    );
                    const { cls, styleAttr } = this.renderServiceItemAttrs(
                        this.options.serviceLiftingBorderColor,
                        this.options.serviceLiftingItemBgColor
                    );
                    const tooltip = this.renderServiceTooltip(
                        this.options.liftingServiceShowTooltip,
                        this.options.liftingServiceDescription
                    );
                    liftingServiceHtml = `
                        <div class="cart-item-service${cls}"${styleAttr}>
                            <label class="service-selector">
                                <input
                                    type="radio"
                                    name="${lifting}"
                                    value="1"
                                    ${isLiftingChecked ? 'checked' : ''}
                                >
                               <span class="cart-item-service-name">
                                    <span class="cart-item-service-name-row">
                                        <span class="cart-item-service-name-text">${this.options.liftingServiceTitle}</span>
                                        ${badge}
                                    </span>
                                    ${tooltip}
                               </span>
                            </label>
                             <span class="plus-price">
                                +${priceFormatted} ${this.options.currencySymbol}
                            </span>
                        </div>
                    `;
                }

                return liftingServiceHtml
            }

            renderLifringAndInstallationService() {
                const liftingAndInstallationServicePrice = this.getLiftingAndInstallationServicePrice();
                const isLiftingAndInstallationChecked = this.normalizeBoolean(this.options.properties[CartItemServicesAndDelivery.ATTR_LIFTING_INSTALLATION]);
                const { liftingInstallation } = this.getInputNames();

                let lifringAndInstallationServiceHtml = '';
                if (liftingAndInstallationServicePrice > 0) {
                    const priceFormatted = this.formatMinorToMajorUnits(liftingAndInstallationServicePrice * this.options.itemQty);
                    const badge = this.renderBadge(
                        this.options.serviceLiftingInstallationBadgeText,
                        this.options.serviceLiftingInstallationBadgeTextColor,
                        this.options.serviceLiftingInstallationBadgeBgColor
                    );
                    const { cls, styleAttr } = this.renderServiceItemAttrs(
                        this.options.serviceLiftingInstallationBorderColor,
                        this.options.serviceLiftingInstallationItemBgColor
                    );
                    const tooltip = this.renderServiceTooltip(
                        this.options.liftingInstallationServiceShowTooltip,
                        this.options.liftingInstallationServiceDescription
                    );

                    lifringAndInstallationServiceHtml = `
                        <div class="cart-item-service${cls}"${styleAttr}>
                            <label class="service-selector">
                                <input
                                    type="radio"
                                    name="${liftingInstallation}"
                                    value="1"
                                    ${isLiftingAndInstallationChecked ? 'checked' : ''}
                                >
                                <span class="cart-item-service-name">
                                    <span class="cart-item-service-name-row">
                                        <span class="cart-item-service-name-text">${this.options.liftingInstallationServiceTitle}</span>
                                        ${badge}
                                    </span>
                                    ${tooltip}
                                </span>
                            </label>
                            <span class="plus-price">
                                +${priceFormatted} ${this.options.currencySymbol}
                            </span>
                        </div>
                    `;
                }

                return lifringAndInstallationServiceHtml;
            }

            renderAdditionalServicesTitle() {
                return `
                    <div class="additional-services-title opened">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.9042 2.10034L20.8037 3.51455L22.2179 13.4141L13.0255 22.6064C12.635 22.997 12.0019 22.997 11.6113 22.6064L1.71184 12.707C1.32131 12.3164 1.32131 11.6833 1.71184 11.2927L10.9042 2.10034ZM11.6113 4.22166L3.83316 11.9998L12.3184 20.4851L20.0966 12.707L19.036 5.28232L11.6113 4.22166ZM13.7327 10.5856C12.9516 9.80457 12.9516 8.53824 13.7327 7.75719C14.5137 6.97615 15.78 6.97615 16.5611 7.75719C17.3421 8.53824 17.3421 9.80457 16.5611 10.5856C15.78 11.3667 14.5137 11.3667 13.7327 10.5856Z" fill="black"/>
                            <path d="M10.9042 2.10034L20.8037 3.51455L22.2179 13.4141L13.0255 22.6064C12.635 22.997 12.0019 22.997 11.6113 22.6064L1.71184 12.707C1.32131 12.3164 1.32131 11.6833 1.71184 11.2927L10.9042 2.10034ZM11.6113 4.22166L3.83316 11.9998L12.3184 20.4851L20.0966 12.707L19.036 5.28232L11.6113 4.22166ZM13.7327 10.5856C12.9516 9.80457 12.9516 8.53824 13.7327 7.75719C14.5137 6.97615 15.78 6.97615 16.5611 7.75719C17.3421 8.53824 17.3421 9.80457 16.5611 10.5856C15.78 11.3667 14.5137 11.3667 13.7327 10.5856Z" fill="black" fill-opacity="0.2"/>
                            <path d="M10.9042 2.10034L20.8037 3.51455L22.2179 13.4141L13.0255 22.6064C12.635 22.997 12.0019 22.997 11.6113 22.6064L1.71184 12.707C1.32131 12.3164 1.32131 11.6833 1.71184 11.2927L10.9042 2.10034ZM11.6113 4.22166L3.83316 11.9998L12.3184 20.4851L20.0966 12.707L19.036 5.28232L11.6113 4.22166ZM13.7327 10.5856C12.9516 9.80457 12.9516 8.53824 13.7327 7.75719C14.5137 6.97615 15.78 6.97615 16.5611 7.75719C17.3421 8.53824 17.3421 9.80457 16.5611 10.5856C15.78 11.3667 14.5137 11.3667 13.7327 10.5856Z" fill="black" fill-opacity="0.2"/>
                            <path d="M10.9042 2.10034L20.8037 3.51455L22.2179 13.4141L13.0255 22.6064C12.635 22.997 12.0019 22.997 11.6113 22.6064L1.71184 12.707C1.32131 12.3164 1.32131 11.6833 1.71184 11.2927L10.9042 2.10034ZM11.6113 4.22166L3.83316 11.9998L12.3184 20.4851L20.0966 12.707L19.036 5.28232L11.6113 4.22166ZM13.7327 10.5856C12.9516 9.80457 12.9516 8.53824 13.7327 7.75719C14.5137 6.97615 15.78 6.97615 16.5611 7.75719C17.3421 8.53824 17.3421 9.80457 16.5611 10.5856C15.78 11.3667 14.5137 11.3667 13.7327 10.5856Z" fill="black" fill-opacity="0.2"/>
                        </svg>
                        ${this.options.additionalServicesTitle}
                    </div>
                `;
            }

            renderAdditionalServices() {
                const liftingServicePrice = this.getLiftingServicePrice();
                const liftingAndInstallationServicePrice = this.getLiftingAndInstallationServicePrice();

                if (!liftingServicePrice && !liftingAndInstallationServicePrice) {
                    return '';
                }

                return `
                    <div class="cart-item-additional-services">
                        ${this.renderAdditionalServicesTitle()}
                        <div class="additional-services-container opened"
                             data-badge-position-desktop="${this.options.badgePositionDesktop || 'under_title'}"
                             data-badge-position-mobile="${this.options.badgePositionMobile || 'under_title'}">
                            ${this.renderDefaultOption()} 
                            ${this.renderLiftingService()} 
                            ${this.renderLifringAndInstallationService()}   
                        </div>
                    </div>
                `;
            }

            render() {
                this.innerHTML = `
                    <div class="cart-item-delivery-and-services">
                        <div class="cart-item-delivery">
                            ${this.renderPackagesQty()}
                            ${this.renderDeliveryDate()}
                        </div>
                        <div class="shipping-price-container">
                            ${this.renderShippingPrice()}
                        </div>
                        ${this.renderAdditionalServices()}
                    </div>
                `;
            }

            attachEvents() {
                //checkboxes handling
                const { lifting, liftingInstallation, noService } = this.getInputNames();
                const liftingServiceCheckbox = this.querySelector(`input[name="${lifting}"]`);
                const liftingInstallServiceCheckbox = this.querySelector(`input[name="${liftingInstallation}"]`);
                const noServiceRadio = this.querySelector(`input[name="${noService}"]`);

                const syncExclusive = (target, other) => {
                    return (event) => {
                        event.stopPropagation();

                        if (target.checked && other) {
                            other.checked = false;
                        }

                        if (noServiceRadio) {
                            noServiceRadio.checked = false;
                        }

                        this.updateCartAttributes(
                            liftingServiceCheckbox?.checked ?? false,
                            liftingInstallServiceCheckbox?.checked ?? false,
                        );
                    };
                };

                if (liftingServiceCheckbox) {
                    liftingServiceCheckbox.addEventListener(
                        'change',
                        syncExclusive(liftingServiceCheckbox, liftingInstallServiceCheckbox)
                    );
                }

                if (liftingInstallServiceCheckbox) {
                    liftingInstallServiceCheckbox.addEventListener(
                        'change',
                        syncExclusive(liftingInstallServiceCheckbox, liftingServiceCheckbox)
                    );
                }

                if (noServiceRadio) {
                    noServiceRadio.addEventListener('change', (event) => {
                        event.stopPropagation();

                        if (liftingServiceCheckbox) liftingServiceCheckbox.checked = false;
                        if (liftingInstallServiceCheckbox) liftingInstallServiceCheckbox.checked = false;

                        this.updateCartAttributes(false, false);
                    });
                }

                // collapsing of additional services
                const additionalServicesTitle = this.querySelector('.additional-services-title');
                const additionalServicesContainer = this.querySelector('.additional-services-container');
                if (additionalServicesTitle && additionalServicesContainer) {
                    additionalServicesTitle.addEventListener('click', (e) => {
                        additionalServicesTitle.classList.toggle('opened');
                        additionalServicesContainer.classList.toggle('opened');
                    });
                }
            }

            extractOptionsFromDataset() {
                const dataset = this.dataset;

                this.options.properties = {};
                this.options.shippingRates = {};

                for (const [attribute, rawValue] of Object.entries(dataset)) {
                    switch (attribute) {
                        case 'properties':
                            this.options[attribute] = this.parseJsonOption(rawValue);
                            break;

                        case 'shippingRates':
                        case 'packagesInfo':
                            this.options[attribute] = this.parseBase64JsonOption(rawValue);
                            break;

                        default:
                            this.options[attribute] = rawValue;
                    }
                }
            }

            /**
             * Parses the cart item properties JSON from a string.
             * Accepts either an object or array of [key, value] pairs.
             */
            parseJsonOption(jsonString) {
                try {
                    const parsed = JSON.parse(jsonString);

                    if (Array.isArray(parsed)) {
                        return parsed.reduce((result, [key, value]) => {
                            result[key] = value;
                            return result;
                        }, {});
                    }

                    if (parsed && typeof parsed === 'object') {
                        return parsed;
                    }

                    return {};
                } catch (error) {
                    console.info('Failed to parse properties JSON:', jsonString, error);
                    return {};
                }
            }

            /**
             * Decodes a Base64-encoded JSON string and parses it.
             */
            parseBase64JsonOption(base64JSonString) {
                try {
                    const decodedString = atob(base64JSonString);
                    return JSON.parse(decodedString);
                } catch (error) {
                    console.info('Failed to decode or parse Base64 JSON:', base64JSonString, error);
                    return {};
                }
            }

            normalizeBoolean(value) {
                return value === true || value === 'true' || value === '1' || value === 1;
            }

            getLiftingServicePrice() {
                const rateEntry = this.findShippingRateByCountryCode(this.options.currentCountryIsoCode);
                const price = parseFloat(rateEntry?.tmd_price) * 100;

                return isNaN(price) ? null : price;
            }

            getLiftingAndInstallationServicePrice() {
                const rateEntry = this.findShippingRateByCountryCode(this.options.currentCountryIsoCode);
                const price = parseFloat(rateEntry?.assembly_delivery_price) * 100;

                return isNaN(price) ? null : price;
            }

            /**
             * Finds a shipping rate entry that matches the given country ISO code.
             * This assumes the shippingRates is an array of objects with Market GIDs as keys,
             * and each object value includes a `locale` like "pl_PL" or a `currency` field.
             */
            findShippingRateByCountryCode(countryIsoCode) {
                if (!Array.isArray(this.options.shippingRates)) return null;

                for (const rateObject of this.options.shippingRates) {
                    const marketGid = Object.keys(rateObject)[0];
                    const rateData = rateObject[marketGid];

                    if (typeof rateData?.locale === 'string') {
                        const localeCountryCode = rateData.locale.split('_')[1]; // e.g., "pl_PL" → "PL"
                        if (localeCountryCode?.toUpperCase() === countryIsoCode?.toUpperCase()) {
                            return rateData;
                        }
                    }
                }

                return null;
            }

            _autoCleanupIfPriceIsZero() {
                const isLiftingSelected = this.normalizeBoolean(this.options.properties[CartItemServicesAndDelivery.ATTR_LIFTING]);
                const isLiftingInstallSelected = this.normalizeBoolean(this.options.properties[CartItemServicesAndDelivery.ATTR_LIFTING_INSTALLATION]);

                if (!isLiftingSelected && !isLiftingInstallSelected) return;

                const shouldClear =
                    (isLiftingSelected && !(this.getLiftingServicePrice() > 0)) ||
                    (isLiftingInstallSelected && !(this.getLiftingAndInstallationServicePrice() > 0));

                if (shouldClear) {
                    this.updateCartAttributes(false, false);
                }
            }

            updateCartAttributes(isLifting, isLiftingInstallation) {

                if (!this.options.linekey) {
                    console.info('Missing linekey info');
                    return;
                }

                const preservedProperties = this.getPreservedCartPropetries();

                if (isLifting) {
                    preservedProperties[CartItemServicesAndDelivery.ATTR_LIFTING] = true;
                } else {
                    preservedProperties[CartItemServicesAndDelivery.ATTR_LIFTING] = null;
                }

                if (isLiftingInstallation) {
                    preservedProperties[CartItemServicesAndDelivery.ATTR_LIFTING_INSTALLATION] = true;
                } else {
                    preservedProperties[CartItemServicesAndDelivery.ATTR_LIFTING_INSTALLATION] = null;
                }

                if (isLifting || isLiftingInstallation) {
                    const randomUniqueueId = preservedProperties[CartItemServicesAndDelivery.ATTR_SERVICE_RELATION_ID] || this.generateUUID();

                    preservedProperties[CartItemServicesAndDelivery.ATTR_SERVICE_RELATION_ID] = randomUniqueueId;
                } else {
                    preservedProperties[CartItemServicesAndDelivery.ATTR_SERVICE_RELATION_ID] = null;
                }

                let sectionsToUpdate = [];
                if (window.FoxTheme) {
                    document.documentElement.dispatchEvent(
                        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToUpdate } })
                    );
                }

                const body = JSON.stringify({
                    id: this.options.linekey,
                    quantity: this.options.itemQty,
                    properties: preservedProperties,
                    sections: sectionsToUpdate
                });

                const radios = this.querySelectorAll('input[type="radio"]');
                radios.forEach(r => r.disabled = true);
                
                window.serviceAndDeliveryUtils.ServicesAndDeliveryUtilsService.setCheckoutBlocked(true);
                fetch(`${FoxTheme.routes.cart_change_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
                    .then((response) => response.json())
                    .then(async (cart) => {
                        if (cart.status) {
                            console.log('Error in status of updateCartAttributes', cart);
                            radios.forEach(r => r.disabled = false);
                            return;
                        }

                        if (cart && Array.isArray(cart.items)) {
                            const relationId = preservedProperties[CartItemServicesAndDelivery.ATTR_SERVICE_RELATION_ID];
                            let matchedIndex = -1;
                            
                            if (relationId) {
                                matchedIndex = cart.items.findIndex(i => i.properties && i.properties[CartItemServicesAndDelivery.ATTR_SERVICE_RELATION_ID] === relationId);
                            } else {
                                matchedIndex = cart.items.findIndex(i => 
                                    i.variant_id == this.options.quantityVariantId &&
                                    !this.normalizeBoolean(i.properties && i.properties[CartItemServicesAndDelivery.ATTR_LIFTING]) &&
                                    !this.normalizeBoolean(i.properties && i.properties[CartItemServicesAndDelivery.ATTR_LIFTING_INSTALLATION])
                                );
                            }

                            if (matchedIndex !== -1) {
                                this.options.linekey = cart.items[matchedIndex].key;
                                this.dataset.linekey = cart.items[matchedIndex].key;
                            }
                        }

                        if (cart.sections) {
                            CartItemServicesAndDelivery._updateCartFooterFromSections(cart.sections);
                        }
 
                        window.dispatchEvent(new CustomEvent('servicesAndDeliveryUtils:cartUpdated', { detail: { cart: cart } }));

                        setTimeout(() => {
                            radios.forEach(r => r.disabled = false);
                        }, 500);
                    })
                    .catch((error) => {
                        radios.forEach(r => r.disabled = false);
                        console.log('Error in updateCartAttributes', error);
                    });
            }

            static _updateCartFooterFromSections(sections) {
                const parser = new DOMParser();

                Object.keys(sections).forEach((sectionId) => {
                    const parsedHTML = parser.parseFromString(sections[sectionId], 'text/html');

                    const newMainItem = parsedHTML.querySelector('.cart__form');
                    const currentMainItem = document.querySelector('.cart__form');
                    if (newMainItem && currentMainItem) {
                        currentMainItem.innerHTML = newMainItem.innerHTML;
                    }

                    const newFooter = parsedHTML.getElementById(`CartDrawerFooter-${sectionId}`);
                    const currentFooter = document.getElementById(`CartDrawerFooter-${sectionId}`);
                    if (newFooter && currentFooter) {
                        currentFooter.innerHTML = newFooter.innerHTML;
                    }

                    const newMainCartFooter = parsedHTML.querySelector('.cart__footer') || parsedHTML.querySelector('.cart__footer-wrapper');
                    const currentMainCartFooter = document.querySelector('.cart__footer') || document.querySelector('.cart__footer-wrapper');
                    if (newMainCartFooter && currentMainCartFooter) {
                        currentMainCartFooter.innerHTML = newMainCartFooter.innerHTML;
                    }

                    const newBubble = parsedHTML.getElementById('cart-icon-bubble');
                    const currentBubble = document.getElementById('cart-icon-bubble');
                    if (newBubble && currentBubble) {
                        currentBubble.innerHTML = newBubble.innerHTML;
                    }
                });

                if (window.formatCustomCurrency) {
                    window.formatCustomCurrency();
                }
            }

            generateUUID() {
                // Try the modern crypto.randomUUID() first
                if (typeof crypto !== 'undefined' && crypto.randomUUID) {
                    return crypto.randomUUID();
                }

                // Fallback for older browsers
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    const r = Math.random() * 16 | 0;
                    const v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }

            getPreservedCartPropetries() {
                const preservedProperties = {};

                for (const [key, val] of Object.entries(this.options.properties)) {
                    if (
                        key !== CartItemServicesAndDelivery.ATTR_LIFTING &&
                        key !== CartItemServicesAndDelivery.ATTR_LIFTING_INSTALLATION &&
                        (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean')
                    ) {
                        preservedProperties[key] = val;
                    }
                }

                return preservedProperties;
            }

            isObjectEmpty(obj) {
                return (
                    obj &&
                    typeof obj === 'object' &&
                    !Array.isArray(obj) &&
                    Object.keys(obj).length === 0
                );
            }

            formatMinorToMajorUnits(amount) {
                let major = amount / 100;
                let formatted = major.toFixed(2);

                return formatted.replaceAll('.', ',');
            }

            getTimeToDeliver() {
                const daysToAdd = Number(this.options.estimatedDeliveryDays);

                if (!Number.isFinite(daysToAdd) || daysToAdd < 1) {
                    return null;
                }

                const startingDate = this.options.presaleDate ? this.parseLocalDate(this.options.presaleDate) : new Date();

                const deliveryDate = window.addBusinessDays(startingDate, daysToAdd);

                // let businessDaysCount = null;
                // try {
                //     const today = new Date();
                //     const tomorrow = new Date(today);
                //     tomorrow.setDate(today.getDate() + 1);

                //     businessDaysCount = window.getBusinessDaysCountBetween(tomorrow, deliveryDate);
                // } catch (error) {
                //     console.error(`Error on receiving time to deliver: ${error.message}`);
                // }

                // if (!businessDaysCount) {
                //     return null;
                // }

                // let title = '';

                // if (businessDaysCount === 1) {
                //     title = this.options.businessDayTitle; // dzień roboczy
                // } else if (
                //     (businessDaysCount % 10 >= 2 && businessDaysCount % 10 <= 4) &&
                //     !(businessDaysCount % 100 >= 12 && businessDaysCount % 100 <= 14)
                // ) {
                //     title = this.options.businessDaysTitle; // dni robocze
                // } else {
                //     title = this.options.businessDaysGenitiveTitle; // dni roboczych
                // }

                // return `${businessDaysCount} ${title}`;

                try {
                    if (!deliveryDate) return '';
            
                    let dateToParse = (typeof deliveryDate === 'string') 
                        ? deliveryDate.trim() 
                        : deliveryDate;
            
                    const dateObj = new Date(dateToParse);
            
                    if (isNaN(dateObj.getTime())) {
                        console.error("Invalid Date provided:", deliveryDate);
                        return '';
                    }
            
                    const locale = document.documentElement.lang || 'pl-PL';
            
                    return dateObj.toLocaleDateString(locale, {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                    });
            
                } catch (error) {
                    console.error("Error in renderDeliveryDate:", error);
                    return '';
                }
            }

            parseLocalDate(input) {
                if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
                    const [y, m, d] = input.split("-").map(Number);
                    return new Date(y, m - 1, d);
                }
                return new Date(input);
            }
        }
    );
}

if (!customElements.get('cart-item-time-to-deliver')) {
    customElements.define('cart-item-time-to-deliver', class extends HTMLElement {
        connectedCallback() {
            const daysToAdd = Number(this.dataset.estimatedDeliveryDays);
            if (!Number.isFinite(daysToAdd) || daysToAdd < 1) return;

            const startingDate = this.dataset.presaleDate ? this.parseLocalDate(this.dataset.presaleDate) : new Date();
            if(!window.addBusinessDays || !window.getBusinessDaysCountBetween) return;

            const deliveryDate = window.addBusinessDays(startingDate, daysToAdd);

            if (!deliveryDate) return '';
            
            let dateToParse = (typeof deliveryDate === 'string') 
                ? deliveryDate.trim() 
                : deliveryDate;
    
            const dateObj = new Date(dateToParse);
    
            if (isNaN(dateObj.getTime())) {
                console.error("Invalid Date provided:", deliveryDate);
                return '';
            }
    
            const locale = document.documentElement.lang || 'pl-PL';
    
            const delivery = dateObj.toLocaleDateString(locale, {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            this.innerHTML = `<span class="delivery-time-content font-body-bold flex gap-1 items-center" style="font-size: 13px; margin-top: 4px;">${this.dataset.estimatedDeliveryTitle}<br> ${delivery}</span>`;
        }

        parseLocalDate(input) {
            if (typeof input === "string" && /^\\d{4}-\\d{2}-\\d{2}$/.test(input)) {
                const [y, m, d] = input.split("-").map(Number);
                return new Date(y, m - 1, d);
            }
            return new Date(input);
        }
    });
}

